import React from 'react'
import ReactTable  from "react-table";
import axios from 'axios'
import {getToken} from '../../storage'
import {API_BASE_URL} from '../../constants'
import DateFormat from '../../utils/dateformat'
import {Link } from 'react-router-dom'



class Retns extends React.Component {
  constructor() {
    super();
    this.state = {
      data: [],
      pages: null,
      loading: true
    };
    this.fetchData = this.fetchData.bind(this);
    this.handleTrclick = this.handleTrclick.bind(this)
    document.title = "Credit Notes List"
  }

  handleTrclick(state,row, column, instance) {
    return {
      onClick : (e, handleOriginal)=>{

        if(row.original.is_generalnote) {
          this.props.history.push('/general_credit_notes/edit/'+row.original.serial)
        }
        else {
          this.props.history.push('/credit_notes/edit/'+row.original.serial)
        }

      },
      style: {
        cursor:'pointer'
      }
    }
  }

  fetchData(state, instance) {
    this.setState({ loading: true });
    let apiurl = "/list_retns/?page=" + state.page + '&page_size='+state.pageSize;
    if(typeof state.sorted !== "undefined" && state.sorted.length > 0) {
        apiurl = apiurl + '&sort_column='+state.sorted[0]['id']
        apiurl = apiurl + '&sort_dir='+state.sorted[0]['desc']
    }
    axios({
      url: apiurl,
      baseURL: API_BASE_URL,
      headers: {
        common: {
          'Authorization': 'Token ' + getToken()
        }
      }
    }).then(res => {
      this.setState({
        data: res.data.retns,
        pages: res.data.pages,
        loading: false
      });
    });
  }

  getSerial(row) {

    if(row.original.is_generalnote) {
      return <span>{row.original.serial} <span className="label label-info">General Credit</span></span>
    }
    else {
      return <span>{row.original.serial} <span className="label label-warning">Invoice Credit</span></span>
    }
  }

  getAmount(row) {
    if(row.original.is_generalnote) {
      return row.original.amount
    }
    else {
      return row.original.totalPrice
    }
  }

  getTax(row) {
    if(row.original.is_generalnote) {
      return 0.00
    }
    else {
      return row.original.totalTax
    }
  }

  getTotal(row){
    if(row.original.is_generalnote) {
      return row.original.totalPrice
    }
    else {
      return row.original.total
    }
  }

  clientNameFormat(row) {

    if(row.original.client !== null) {
      const client = row.original.client
      return <div>{client.name} {client.city}</div>
    }
    else {
      return null
    }
  }

  render() {

    const { data, pages, loading } = this.state;
    const columns = [
      {Header:'ID', accessor:'serial', Cell:(row)=>(<div>{this.getSerial(row)}</div>) },
      {Header:'Client', accessor: 'client.name',sortable:false, Cell:(row)=>{return this.clientNameFormat(row)} },
      {Header:'Date', accessor: 'date', sortable:false, Cell:(row)=>(<DateFormat date={row.original.date}/>)},
      {Header:'Amount',  accessor:'totalPrice',sortable:true, Cell:(row)=>(<div className="text-right">{row.original.totalPrice}</div>) },
      {Header:'Tax',  accessor:'totalTax', sortable:true, Cell:(row)=>(<div className="text-right">{this.getTax(row)}</div>) },
      {Header:'Total',  accessor:'total', sortable:true, Cell:(row)=>(<div className="text-right">{this.getTotal(row)}</div>) },
    ]
    const defaultSort=[{id: "serial", desc: true}]
    return <div><section className="medium">
      <ul className="list-inline">
        <li><Link to="/credit_notes/create" className="btn btn-primary">Create New Invoice Credit Note</Link></li>
        <li><Link to="/general_credit_notes/create" className="btn btn-primary">Create New General Credit Note</Link></li>
      </ul>
    </section>
    <div className="row">
      <div className="col-sm-12">
        <div className="table-responsive">
          <ReactTable defaultSorted={defaultSort}
            getTrProps={this.handleTrclick}
            noDataText="No Retns Found."
              columns={columns} manual data={data}
              pages={pages} loading={loading} onFetchData={this.fetchData} minRows={5} defaultPageSize={20} />
        </div>

      </div>
    </div>

    </div>
  }
}

//
// const mapStateToProps = (state) => {
//   return {
//     retn: state.retnReducer
//   }
// }

export default Retns;



// WEBPACK FOOTER //
// ./src/components/credit/creditlist.js